export default {
  users: {
    mobileConfirmed: 'Mobile confirmed',
    userRemoved: 'User removed',
    userUpdated: 'User updated',
    userAdded: 'User added',
    user: 'User',
    gender: 'Gender',
    newUser: 'New User',
    birthDate: 'Birth data',
    twoFactorEnabled: 'Two factor enabled',
    roles: 'Roles',
    rolesInRealm: 'Roles in {name}',
    editUserRoles: 'Edit user roles',
    userRolesUpdated: 'User roles updated',

    // Project
    bloodGroup: 'Blood group',
    drugs: 'Drugs',
    heartDiseases: 'Past medical history',
    operationAreaAddress: 'Operation area address',
    organization: 'Organization',
    organizationCode: 'Organization code',
    relativePhone: 'Relative phone',
    relativePhone1: 'Relative phone 1',
    relativePhone2: 'Relative phone 2',
    relativePhone3: 'Relative phone 3',
    socialHabits: 'Social habits',
    weight: 'Weight',
    legal: 'Legal',
    natural: 'Natural'
  }
}
